import Reveal from "./Reveal";
import { Lock } from "lucide-react";

const STANDARDS = [
  { id: "research", strong: "Research", rest: "before production." },
  { id: "testing", strong: "Testing", rest: "before assumptions." },
  { id: "quality", strong: "Quality", rest: "before quantity." },
  { id: "roi", strong: "ROI", rest: "before vanity metrics." },
];

export default function Standards() {
  return (
    <>
      <section className="bg-white py-28 sm:py-40" data-testid="standards-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <Reveal className="max-w-3xl">
            <span className="eyebrow text-[#86868b]">Our standards</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.06] text-[#1d1d1f]">
              How we operate
            </h2>
          </Reveal>
          <div className="mt-16">
            {STANDARDS.map((s, i) => (
              <Reveal key={s.id} delay={i * 0.07} y={20}>
                <div
                  className="group border-t border-black/[0.08] py-8 sm:py-10 transition-all duration-300 hover:pl-4"
                  data-testid={`standard-${s.id}`}
                >
                  <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em]">
                    <span className="text-[#1d1d1f]">{s.strong}</span>{" "}
                    <span className="text-[#aeaeb2] transition-colors duration-300 group-hover:text-[#6e6e73]">
                      {s.rest}
                    </span>
                  </h3>
                </div>
              </Reveal>
            ))}
            <div className="border-t border-black/[0.08]" />
          </div>
        </div>
      </section>

      <section className="bg-[#0a0a0a] py-24 sm:py-32" data-testid="privacy-section">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-white/15 text-white/70">
              <Lock className="h-5 w-5" strokeWidth={1.5} />
            </span>
            <h2 className="mt-8 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-white">
              Your business stays your business.
            </h2>
            <p className="mt-6 text-[#a1a1a6] text-lg sm:text-xl leading-relaxed max-w-xl mx-auto">
              We don't publish client work, results, screenshots or testimonials without permission.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
